import axios from '@/plugins/axios.js';
const resource = 'relatorio/empresa';

export default {
    recuperarEmpresasAtivas() {
        return axios.get(`${resource}/recuperarEmpresasAtivas`);
    },
};